export const ITEMS_PER_PAGE_DEFAULT = {
    s: 1,
    m: 2,
    l: 3,
    xl: 4,
};
export const COL_WIDTH_DEFAULT = {
    s: 6 / 6,
    m: 5 / 12,
    l: 4 / 12,
    xl: 3 / 12,
};
export const bgColors = {
    s: '#faffd3',
    m: '#c9ffe1',
    l: '#ffd3f3',
    xl: '#d3f0ff',
};
//# sourceMappingURL=constants.js.map